import MuiTypography, { TypographyProps } from '@mui/material/Typography';

function Text(props: TypographyProps) {
  return <MuiTypography {...props} />;
}

export default Text;
